<template>
  <ChatModal title="New chat" width="520px" @close="$emit('close')">
    <label class="chat-label d-block mb-1" for="newChatToInput">To</label>
    <div class="d-flex align-items-start" style="gap: 8px">
      <RecipientPicker input-id="newChatToInput" v-model="to" class="flex-grow-1" style="min-width: 0" :exclude-ids="cc.map((u) => u.id)" placeholder="Search people by name…" />
      <button
        type="button"
        class="cc-toggle"
        :class="{ 'cc-toggle--on': showCc }"
        :title="showCc ? 'Remove Cc' : 'Copy someone (Cc)'"
        @click="toggleCc"
      >
        <i class="fe fe-users"></i>
      </button>
    </div>

    <div v-if="showCc" class="mt-3">
      <label class="chat-label d-block mb-1" for="newChatCcInput">Cc</label>
      <RecipientPicker input-id="newChatCcInput" v-model="cc" :exclude-ids="to.map((u) => u.id)" placeholder="Copy someone (optional)" />
    </div>

    <div class="d-flex justify-content-end mt-4" style="gap: 8px">
      <button type="button" class="btn btn-outline-secondary" @click="$emit('close')">Cancel</button>
      <button type="button" class="btn chat-btn px-4" :disabled="!to.length || checking" @click="start">
        <span v-if="checking" class="spinner-border spinner-border-sm mr-1"></span> Chat
      </button>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from "./ChatModal.vue";
import RecipientPicker from "./RecipientPicker.vue";
import api from "../api";

// Pick who to chat with. One person and no Cc reopens the existing chat with
// them; otherwise the parent opens a new chat that is created on the first message.
export default {
  name: "NewChatModal",
  components: { ChatModal, RecipientPicker },
  data() {
    return { to: [], cc: [], showCc: false, checking: false };
  },
  methods: {
    toggleCc() {
      this.showCc = !this.showCc;
      if (!this.showCc) this.cc = [];
    },
    start() {
      if (this.to.length === 1 && !this.cc.length) {
        this.checking = true;
        api
          .conversations({ with: this.to[0].id, per_page: 1 })
          .then((res) => {
            if (res.data.length) this.$emit("open", res.data[0].id);
            else this.$emit("draft", { to: this.to, cc: this.cc });
          })
          .catch(() => this.$emit("draft", { to: this.to, cc: this.cc }))
          .finally(() => {
            this.checking = false;
          });
        return;
      }
      this.$emit("draft", { to: this.to, cc: this.cc });
    },
  },
};
</script>

<style scoped>
.cc-toggle {
  position: relative;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 0;
  background: #f1f5f9;
  color: #475569;
  font-size: 1rem;
}
.cc-toggle:hover,
.cc-toggle--on {
  background: #eef2ff;
  color: #2563eb;
}
</style>
